import React, { useState, useEffect } from 'react'
import { find, result } from 'libraries/lodash'
import ReactResizeDetector from 'react-resize-detector'
import Grid from '@material-ui/core/Grid'
import connect from 'front-end-core/decorators/connect'
import pageSetup from 'constants/mw-analytics-parameters'
import { getDocumentConfiguration, requestEventTypes } from 'services/DealwatchService'
import ResponseConsumer from 'pages/share/Main'
import Plot, { PlotSkeleton } from 'pages/mwanalytics/Plot'

const getDealTypes = eventTypes => Object.values(eventTypes).map(({ type, name }) => ({
  label: name,
  value: type
}))

const Content = ({ content, dealType, interval, documentConfiguration, width, flavour }) => {
  const [isResizing, setIsResizing] = useState(true)

  useEffect(() => {
    setIsResizing(true)

    const timerId = setTimeout(() => {
      setIsResizing(false)
    }, 500)

    return () => clearTimeout(timerId)
  }, [width, setIsResizing])

  return (
    <div>
      {content.map((content, index) => (
        <Grid key={index} container spacing={1}>
          {content.map((config, index) => {
            const isLast = (index + 1) === content.length
            const isOdd = (index + 1) % 2 !== 0
            const fullWidth = isLast && isOdd

            return (
              <Grid item xs={12} sm={fullWidth ? 12 : 6} md={fullWidth ? 12 : 6} key={dealType + index}>
                {!isResizing && (
                  <Plot
                    animation
                    index={index}
                    key={dealType + index}
                    {...config}
                    {...{ interval, dealType, documentConfiguration, flavour }}
                  />
                )}
                {isResizing && <PlotSkeleton key={dealType + index} />}
              </Grid>
            )
          })}
        </Grid>
      ))}
    </div>
  )
}

const Statistics = ({ query, eventTypes, documentConfiguration, flavour }) => {
  const { i: interval, t: dealTypeSelected } = query
  const dealTypes = getDealTypes(eventTypes)
  const { label, value: dealType } = find(dealTypes, ({ value }) => (
    value === dealTypeSelected
  ))
  const content = result(pageSetup, dealType, [])

  return (
    <div className='layout-width-constraint mt6'>
      <h2 className='f4 bt bb b--black pa4 mb6 fw4 mt0'>{label}</h2>
      <ReactResizeDetector handleWidth>
        <Content {...{ content, dealType, interval, documentConfiguration, flavour }} />
      </ReactResizeDetector>
    </div>
  )
}

const ConnectedStatistics = connect(() => ({
  eventTypes: requestEventTypes(),
  documentConfiguration: getDocumentConfiguration()
}))((props) => (
  <ResponseConsumer
    responses={[props.eventTypes, props.documentConfiguration]}
    content={() => <Statistics {...props} />}
  />
))

export default ConnectedStatistics
